import { ORG_ROUTE_ACCESS } from '@/config/routeAccessRegistry';
import { resolveRouteAccessRule } from '@/config/routeAccessUtils';
import { resolveModuleAdminRoutePermission } from '@/config/moduleDefaults';

/** Routes any signed-in workspace user may open — no view permission codes required. */
export function isOpenAccessRoute(pathname: string): boolean {
  const path = pathname.split('?')[0];
  if (resolveModuleAdminRoutePermission(path) === null) return true;
  const rule = resolveRouteAccessRule(path, ORG_ROUTE_ACCESS);
  return rule != null && (rule.view === null || rule.view === undefined);
}
